import type { DealStage, DealStrategy, EngagementStatus } from "./api";

/** §6.2 order, used for the pipeline board lanes. */
export const DEAL_STAGE_ORDER: readonly DealStage[] = [
  "contract",
  "due_diligence",
  "entitlement",
  "funded",
  "closed_acquisition",
  "marketing",
  "under_contract_sale",
  "closed_sale",
  "terminated",
];

export const DEAL_STAGE_LABEL: Record<DealStage, string> = {
  contract: "Contract",
  due_diligence: "Due diligence",
  entitlement: "Entitlement",
  funded: "Funded",
  closed_acquisition: "Closed (acq)",
  marketing: "Marketing",
  under_contract_sale: "Under contract (sale)",
  closed_sale: "Closed (sale)",
  terminated: "Terminated",
};

export const STRATEGY_LABEL: Record<DealStrategy, string> = {
  flip: "Flip",
  deed_split: "Exempt deed split",
  minor_plat: "Minor plat",
  major_subdivision: "Major subdivision",
  rezoning: "Rezoning",
  wholesale_assignment: "Wholesale / assignment",
  double_close: "Double close",
  hold: "Hold",
};

export function dealStageTone(stage: DealStage): "ok" | "info" | "warn" | "danger" | "muted" {
  switch (stage) {
    case "closed_sale":
      return "ok";
    case "terminated":
      return "danger";
    case "contract":
    case "due_diligence":
      return "warn";
    case "entitlement":
    case "funded":
    case "closed_acquisition":
    case "marketing":
    case "under_contract_sale":
      return "info";
    default:
      return "muted";
  }
}

/** §6.3 order for the engagement board. */
export const ENGAGEMENT_STATUS_ORDER: readonly EngagementStatus[] = [
  "rfq_draft",
  "rfq_sent",
  "quoted",
  "engaged",
  "in_progress",
  "delivered",
  "accepted",
  "rejected",
  "cancelled",
];

export const ENGAGEMENT_STATUS_LABEL: Record<EngagementStatus, string> = {
  rfq_draft: "RFQ draft",
  rfq_sent: "RFQ sent",
  quoted: "Quoted",
  engaged: "Engaged",
  in_progress: "In progress",
  delivered: "Delivered",
  accepted: "Accepted",
  rejected: "Rejected",
  cancelled: "Cancelled",
};

export const CHECKLIST_CATEGORY_LABEL: Record<string, string> = {
  title: "Title",
  survey: "Survey",
  access: "Access",
  flood: "Flood",
  environmental: "Environmental",
  soils: "Soils",
  utilities: "Utilities",
  zoning: "Zoning",
  plat: "Plat",
  restrictions: "Restrictions",
  taxes: "Taxes",
  minerals: "Minerals",
  other: "Other",
};

export const VENDOR_TYPES = [
  "surveyor", "soil_scientist", "civil_engineer", "land_planner", "architect",
  "land_use_attorney", "closing_attorney", "title_company", "realtor_broker", "geotech",
  "environmental", "excavation_contractor", "utility_provider", "county_staff", "appraiser",
  "lender", "data_provider", "other",
] as const;

export const ENGAGEMENT_SERVICES = [
  "boundary_survey", "topo_survey", "plat_prep", "perc_test", "soil_map", "phase_1_esa",
  "wetlands_delineation", "geotech", "civil_design", "site_plan", "drainage_study",
  "rezoning_application", "variance", "title_search", "title_commitment", "closing", "listing",
  "buyer_rep", "bpo_appraisal", "utility_capacity_letter", "clearing_road", "funding",
  "legal_review", "other",
] as const;

export function humanise(value: string): string {
  return value.replace(/_/g, " ").replace(/^./, (c) => c.toUpperCase());
}
